(() => {
  const script=document.querySelector('script[data-clean-mobile-video]');
  if(script?.dataset.cleanMobileVideo!=='true')return;
  const mobile=matchMedia('(max-width: 749px)');
  const originals=new WeakMap();
  const bound=new WeakSet();
  function apply(video){
    if(!originals.has(video))originals.set(video,video.hasAttribute('controls'));
    if(mobile.matches){video.controls=false;video.playsInline=true;video.setAttribute('playsinline','');video.disablePictureInPicture=true;video.setAttribute('controlslist','nodownload nofullscreen noremoteplayback');}
    else video.controls=originals.get(video);
    if(!bound.has(video)){
      bound.add(video);
      video.addEventListener('click',()=>{if(mobile.matches&&!video.closest('.bv-editorial-media:has(.bv-post-open)')){if(video.paused)video.play().catch(()=>{});else video.pause();}});
    }
  }
  const scan=root=>{if(root.matches?.('video'))apply(root);root.querySelectorAll?.('video').forEach(apply);};
  scan(document);
  mobile.addEventListener('change',()=>scan(document));
  new MutationObserver(records=>records.forEach(r=>{
    if(r.type==='attributes'&&r.target.tagName==='VIDEO'&&mobile.matches&&r.target.controls)r.target.controls=false;
    r.addedNodes.forEach(n=>{if(n.nodeType===1)scan(n);});
  })).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['controls']});
})();
